import {
  DraftConfiguration,
  DraftDesignConfiguration,
  DraftSpecialTextConfiguration,
} from '@/types';
import { isPixelDesign } from '@/model/design/isDesignType';
import {
  isDraftDesignConfiguration,
  isDraftSpecialTextConfiguration,
} from './isDraftConfigurationType';

export const isPixelDraftConfiguration = (
  configuration: DraftConfiguration
): configuration is DraftDesignConfiguration | DraftSpecialTextConfiguration =>
  (isDraftDesignConfiguration(configuration) && isPixelDesign(configuration.design)) ||
  isDraftSpecialTextConfiguration(configuration);
